import { RouteLink } from 'components/RouteLink/RouteLink.styles'
import {
  BUSINESS_PAGE_URL,
  PRIVACY_POLICY_URL,
  TERMS_OF_SERVICE_URL,
  COOKIE_POLICY_URL,
} from '../../../config/config'
import { useTranslation } from 'react-i18next'
import * as S from './MenuFooter.styles'
import LanguageSelector from '../../LanguageSelector/LanguageSelector'
import { analytics, EVENT_NAMES } from '../../../services/Analytics/Analytics'

function MenuFooter() {
  const { t } = useTranslation()

  const handlePrivacyPolicyClicked = () => {
    analytics.track(EVENT_NAMES.MENU_ITEM_TAPPED, {
      Item: 'PRIVACY_POLICY_LINK',
    })
  }

  const handleCookiePolicyClicked = () => {
    analytics.track(EVENT_NAMES.MENU_ITEM_TAPPED, {
      Item: 'COOKIE_POLICY_LINK',
    })
  }

  const handleTermsOfUseClicked = () => {
    analytics.track(EVENT_NAMES.MENU_ITEM_TAPPED, { Item: 'TERMS_OF_USE' })
  }

  const handleBusinessClicked = () => {
    analytics.track(EVENT_NAMES.MENU_ITEM_TAPPED, { Item: 'BUSINESS' })
  }

  return (
    <S.Container>
      <S.SubMenu>
        <RouteLink to={BUSINESS_PAGE_URL} onClick={handleBusinessClicked}>
          {t('general.menu.for_business')}
        </RouteLink>
        <RouteLink to={PRIVACY_POLICY_URL} onClick={handlePrivacyPolicyClicked}>
          {t('general.menu.privacy_policy')}
        </RouteLink>
        <RouteLink to={COOKIE_POLICY_URL} onClick={handleCookiePolicyClicked}>
          {t('general.menu.cookie_policy')}
        </RouteLink>
        <S.Link onClick={() => window.UC_UI.showSecondLayer()}>
          {t('homepage.cookies_choices')}
        </S.Link>
        <RouteLink to={TERMS_OF_SERVICE_URL} onClick={handleTermsOfUseClicked}>
          {t('general.gdpr_dialog.terms_of_use')}
        </RouteLink>
        <div data-acsb-custom-trigger="true">
          {t('general.menu.accessibility_button')}
        </div>
      </S.SubMenu>
      <S.LanguageContainer>
        <LanguageSelector />
      </S.LanguageContainer>
    </S.Container>
  )
}

export default MenuFooter
